<template>
  <pt-news-classify class="pt-news-classify__page"></pt-news-classify>
</template>

<script>
import PtNewsClassify from 'cps/information-manage/pt-news-manage/pt-news-classify/withData'
export default {
  name: 'pt-news-classify__view',
  components: {
    'pt-news-classify': PtNewsClassify
  }
}
</script>
